// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__H-S7v","type":"styles_type__16OwI","choices":"styles_choices__2AH0o"};